export class USAePay {
    firstName: string;
    lastName: string;
    homeAddressLine1: string;
    homeAddressLine2: string;
    homeCity: string;
    homeZipCode: string;
    homeState: string;
    homeEmail: string;
    existingCardInformation: string;
    isTestPayServerDeactivated: boolean;

    constructor() {
        this.firstName = null;
        this.lastName = null;
        this.homeAddressLine1 = null;
        this.homeAddressLine2 = null;
        this.homeCity = null;
        this.homeZipCode = null;
        this.homeState = null;
        this.homeEmail = null;
        this.existingCardInformation = null;
        this.isTestPayServerDeactivated = false;
    }
}

export class USAePayPayload extends USAePay {
    cardExpiration: string;
    cardNumber: string;
    sendReceipt: boolean;
    constructor() {
        super();
        this.cardExpiration = null;
        this.cardNumber = null;
        this.sendReceipt = false;
    }
}